import { Button } from "@/components/ui/button";
import { Gift } from "lucide-react";

const GIFT_CARD_URL = "https://uplevelcleaning.bookingkoala.com/gift-cards/send";

export const GiftCards = () => {
  return (
    <section className="py-24 bg-muted relative overflow-hidden">
      <div className="container relative z-10">
        <div className="bg-primary text-primary-foreground rounded-3xl p-8 md:p-16 text-center max-w-5xl mx-auto shadow-xl relative overflow-hidden">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl" />

          <div className="relative z-10 flex flex-col items-center">
            <div className="bg-white/20 p-4 rounded-full mb-6">
              <Gift className="h-12 w-12 text-white" />
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-6">Give the Gift of a Clean Home</h2>
            <p className="text-xl opacity-90 mb-10 max-w-2xl mx-auto">
              Perfect for new parents, busy professionals, or anyone who deserves a break. Treat your loved ones in Sacramento to the luxury of free time.
            </p>
            <Button asChild size="lg" className="bg-white text-primary hover:bg-white/90 font-bold text-lg px-10 py-6 h-auto rounded-xl shadow-lg hover:shadow-xl transition-all">
              <a href="/gift-cards">Buy a Gift Card</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
